import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { combineReducers } from 'redux';

import { getCurrentUserFromGlobal, userIsConnected } from 'lib/current-user';
import { getGlobalAppVar } from '@openclassrooms/utils/global-app';
import { setCurrentUserId } from 'Modules/currentUser/actions';

import state from '../../state';
import { receiveUser } from '../../state/users/actions';

const store = {};
const asyncReducers = {};

store.get = () => {
  if (!store.exists()) {
    store.create();
  }
  return getGlobalAppVar().store;
};

store.create = () => {
  const app = getGlobalAppVar();
  app.store = state.createReduxStore();
  const user = getCurrentUserFromGlobal();
  if (userIsConnected()) {
    store.dispatch(receiveUser(user));
    store.dispatch(setCurrentUserId(user.id));
  }
};

store.exists = () => !!getGlobalAppVar().store;

store.dispatch = (action) => store.get().dispatch(action);

store.wrapElementWithProvider = (reactElement) =>
  createElement(Provider, { store: store.get() }, reactElement);

store.renderElementWrappedWithProvider = (reactElement, targetElement) => {
  const root = createRoot(targetElement);
  root.render(store.wrapElementWithProvider(reactElement));
};

store.addReducer = (name, reducer) => {
  const currentStore = store.get();
  asyncReducers[name] = reducer;

  currentStore.replaceReducer(
    combineReducers({
      ...state.reducersObject,
      ...asyncReducers,
    })
  );
};

export default store;

// keep old export for compatibility
export const getStore = store.get;
export const createStore = store.create;
export const isStoreExist = store.exists;
export const dispatchToStore = store.dispatch;
export const wrapElementWithStoreProvider = store.wrapElementWithProvider;
export const renderElementWithStore = store.renderElementWrappedWithProvider;
